/* eslint-disable quotes */
<template>
	<Transition name="nav-slide">
		<div class="banner-wrapper d-flex justify-content-center align-items-center" v-if="showBanner">
			<div class="banner-content flex-row align-items-center justify-content-center d-none d-md-flex">
				<div v-if="bannerImage">
					<img :src="bannerImage" style="max-height: 35px;" />
				</div>
				<div class="d-flex flex-row align-items-center headline" :style="{ color: headlineColor }">
					<InlineSvg v-if="headlineIcon" :src="headlineIcon" />
					<template v-if="headline">{{ headline }}</template>
				</div>
				<div v-if="coundtdown" class="d-flex flex-row align-items-center" :style="{ color: countdownColor }">
					<AppCountdown class="countdown" :countdownTime="coundtdown" @countdown-finished="countdownFinished" />
				</div>
				<div
					v-if="showButton && buttonStyle === 'button'"
					class="d-flex flex-row align-items-center button cursor-pointer"
					:style="{ backgroundColor: buttonBGColor, color: buttonColor }"
					@click="goToButtonLink"
				>
					<template v-if="buttonText">{{ buttonText }}</template>
					<InlineSvg v-if="buttonIcon" :src="buttonIcon" />
				</div>
				<div
					v-if="showButton && buttonStyle === 'line'"
					class="d-flex flex-row align-items-center button line cursor-pointer"
					:style="{ color: buttonColor }"
					@click="goToButtonLink"
				>
					<template v-if="buttonText">{{ buttonText }}</template>
					<InlineSvg v-if="buttonIcon" :src="buttonIcon" />
				</div>
				<InlineSvg
					v-if="showClose"
					@click="closeBanner"
					style="right: 10px;"
					class="close-ico position-absolute cursor-pointer"
					src="/images/icons/ic-close.svg"
				/>
			</div>

			<div class="banner-content flex-row align-items-center justify-content-center d-flex d-md-none">
				<div v-if="bannerImageMobile">
					<img :src="bannerImageMobile" style="max-height: 35px;" />
				</div>
				<div class="d-flex flex-row align-items-center headline" :style="{ color: headlineColor }">
					<InlineSvg v-if="headlineIcon" :src="headlineIcon" />
					<template v-if="headlineMobileText">{{ headlineMobileText }}</template>
				</div>
				<div v-if="countdownShowMobile && coundtdown" class="d-flex flex-row align-items-center" :style="{ color: countdownColor }">
					<AppCountdown class="countdown" :countdownTime="coundtdown" @countdown-finished="countdownFinished" />
				</div>
				<div
					v-if="showButton && buttonStyle === 'button'"
					class="d-flex flex-row align-items-center button cursor-pointer"
					:style="{ backgroundColor: buttonBGColor, color: buttonColor }"
					@click="goToButtonLink"
				>
					<template v-if="buttonMobileText">{{ buttonMobileText }}</template>
					<InlineSvg v-if="buttonIcon" :src="buttonIcon" />
				</div>
				<div
					v-if="showButton && buttonStyle === 'line'"
					class="d-flex flex-row align-items-center button line cursor-pointer"
					:style="{ color: buttonColor }"
					@click="goToButtonLink"
				>
					<template v-if="buttonMobileText">{{ buttonMobileText }}</template>
					<InlineSvg v-if="buttonIcon" :src="buttonIcon" />
				</div>
				<InlineSvg v-if="showClose" @click="closeBanner" class="close-ico cursor-pointer" src="/images/icons/ic-close.svg" />
			</div>
		</div>
	</Transition>
</template>
<script>
	import OnboardingMixin from '~/pages/dashboard/OnboardingMixin.js'
	import { mapGetters, mapActions } from 'vuex'

	export default {
		middleware: 'auth',
		mixins: [OnboardingMixin],
		emits: ['toggled'],
		data() {
			return {
				configCheck: 0,
				showingBanner: undefined,
				bannerClickClosed: false,
			}
		},
		async created() {
			if (!this.initalized) {
				await this.fetchConfigs()
			}
			this.showBannerCheck(this.showBanner)
		},
		computed: {
			...mapGetters('Configs', ['eventBanners', 'initalized']),
			config() {
				// Forces a recheck
				this.configCheck
				return this.firstValidConfig()
			},
			cookieBannerCloseCount() {
				return Number(this.$cookies.get(`bannerClosed-${this.config?.banner_key}`, 0))
			},
			cookiesBannerClosed() {
				if (this.config?.hide_after_closes) {
					return this.cookieBannerCloseCount > this.config.hide_after_closes
				}
				return false
			},
			sessionBannerClosed() {
				return sessionStorage.getItem(`bannerClosed-${this.config?.banner_key}`) === 'true'
			},
			showClose() {
				return this.config?.showClose ?? true
			},
			bannerBackground() {
				return this.config.backgroundColor || '#000000'
			},
			// Banner Image
			bannerImage() {
				return this.config.image.desktop
			},
			bannerImageMobile() {
				return this.config.image.mobile
			},
			// Headline
			headlineIcon() {
				return this.config.headline.icon
			},
			headlineColor() {
				return this.config?.headline.color ?? '#0f0000'
			},
			headline() {
				return this.config.headline.text
			},
			headlineMobileText() {
				return this.config.headline.mobileText || this.config.headline.text
			},
			// Coundtdown
			countdownShowMobile() {
				return this.config?.countdown?.showMobile ?? false
			},
			coundtdown() {
				return this.config?.countdown?.time
			},
			countdownColor() {
				return this.config?.countdown?.color ?? '#0f0000'
			},
			// Button
			showButton() {
				return (this.config.button.text || this.config.button.icon) && this.config.button.link
			},
			buttonStyle() {
				return (this.config.button?.style ?? 'button').toLowerCase()
			},
			buttonText() {
				return this.config.button.text
			},
			buttonMobileText() {
				return this.config.button.mobileText || this.config.button.text
			},
			buttonIcon() {
				return this.config.button.icon
			},
			buttonBGColor() {
				return this.config.button?.bg ?? 'var(--stan-primary-primary-color)'
			},
			buttonColor() {
				return this.config.button?.color ?? 'var(--stan-white)'
			},
			showBanner() {
				if (this.bannerClickClosed || this.sessionBannerClosed || this.cookiesBannerClosed) {
					return false
				}
				if (this.config) {
					return !!(this.headline || this.bannerImage)
				}
				return false
			},
		},
		methods: {
			...mapActions('Configs', ['fetchConfigs']),
			checkCondition(condition) {
				if (condition?.type === 'route') {
					if (this.$router.currentRoute.name.toLowerCase() === condition.value.toLowerCase()) {
						return true
					}
				}
				if (condition?.type === 'experiment') {
					if (this.user.experiments[condition.value] === 1) {
						return true
					}
				}
				if (condition?.type === 'start_date') {
					if (new Date() > new Date(condition.value)) {
						return true
					}
				}
				if (condition?.type === 'end_date') {
					if (new Date() < new Date(condition.value)) {
						return true
					}
				}
				if (condition?.type === 'exclude') {
					if (this.user.experiments[condition.value] === 1) {
						return false
					}
				}

				// For intenral testing
				if (condition?.type === 'role') {
					if (this.user.list_of_roles.includes(condition.value)) {
						return true
					}
				}
				return false
			},
			firstValidConfig() {
				// Referenced to force a recheck

				for (const config of this.eventBanners) {
					let useConfig = true
					if (config.conditions?.include?.length > 0) {
						for (const include of config.conditions.include) {
							if (!this.checkCondition(include)) {
								useConfig = false
								break
							}
						}
					}
					if (config.conditions?.exclude?.length > 0) {
						for (const exclude of config.conditions.exclude) {
							if (this.checkCondition(exclude)) {
								useConfig = false
								break
							}
						}
					}

					if (useConfig) {
						return config
					}
				}
				return null
			},
			showBannerCheck(showBanner) {
				this.$emit('toggled', showBanner)
			},
			goToButtonLink() {
				if (this.config.button.link) {
					window.open(this.config.button.link, '_self')
				}
			},
			countdownFinished() {
				this.configCheck++
			},
			closeBanner() {
				this.bannerClickClosed = true
				sessionStorage.setItem(`bannerClosed-${this.config?.banner_key}`, true)
				this.$cookies.set(`bannerClosed-${this.config?.banner_key}`, this.cookieBannerCloseCount + 1)
			},
		},
		watch: {
			showBanner(newVal) {
				this.showBannerCheck(newVal)
			},
		},
	}
</script>
<style lang="scss" scoped>
	.banner-wrapper {
		background: #000;
		color: #fff;
		min-height: 42px;
		min-height: 42px;

		.banner-content {
			padding-left: 13px;
			padding-right: 13px;
			gap: 12px;
			font-size: 13px;

			.headline {
				line-height: 1;
				color: #fff;
				font-family: 'Plus Jakarta Sans';
				font-style: normal;
				font-weight: 700;
				letter-spacing: 0.13px;
				gap: 4px;
			}

			.countdown {
				line-height: 1;
				width: 100px;
				font-size: 13px;
			}

			.button {
				line-height: 1;
				font-size: 12px;
				border-radius: 8px;
				margin: 5px;
				max-height: 35px;
				padding: 8px 11px 8px 10px;
				white-space: nowrap;

				&.line {
					text-decoration: underline;
				}
			}

			svg {
				width: 18px;
				height: 18px;
				&::v-deep {
					path:not(.no-fill),
					rect:not(.no-fill) {
						fill: #fff;
					}
				}
			}
		}

		@media (min-width: 992px) {
			min-height: 50px;
			max-height: 50px;

			.banner-content {
				gap: 16px;

				.headline {
					font-size: 13px;
				}

				.countdown {
					min-width: 150px;
					font-size: 16px;
				}
			}
		}
	}

	.nav-slide-enter-active,
	.nav-slide-leave-active {
		transition: transform 0.3s ease, opacity 0.3s ease;
	}

	.nav-slide-enter,
	.nav-slide-leave-to {
		transform: translateY(-100%);
		background-color: white;
	}
</style>
